<div class="sync-progress-container" *ngIf="progress$ | async as progress">
  <div class="sync-progress-header">
    <div class="sync-progress-title">
      <span class="provider-name">{{ provider === 'GOOGLE' ? 'Google Workspace' : provider === 'MICROSOFT' ? 'Microsoft' : 'Calamari' }}</span>
    </div>
    <div class="sync-progress-status" [class.completed]="isCompleted(progress.status)">
      <mat-icon *ngIf="progress.status === 'COMPLETED_SUCCESSFULLY'" class="status-icon success">check_circle</mat-icon>
      <mat-icon *ngIf="progress.status === 'IN_PROGRESS'" class="status-icon in-progress">sync</mat-icon>
      <mat-icon *ngIf="progress.status === 'SAVING'" class="status-icon saving">save</mat-icon>
      <mat-icon *ngIf="progress.status === 'ERROR'" class="status-icon error">warning</mat-icon>
      <mat-icon *ngIf="progress.status === 'COMPLETED_WITH_ERROR'" class="status-icon success">check_circle</mat-icon>
    </div>
  </div>
  
  <div class="sync-progress-bar-wrapper">
    <mat-progress-bar 
      mode="determinate" 
      [value]="displayedPercentage"
      [class.completed]="isCompleted(progress.status)"
      [class.error]="progress.status === 'COMPLETED_WITH_ERROR' || progress.status === 'ERROR'"
      [class.warning]="progress.status === 'COMPLETED_WITH_ERROR' || progress.status === 'ERROR'">
    </mat-progress-bar>
    <div class="progress-text">{{ getProgressSummary(progress) }}</div>
  </div>
  
  <div class="sync-details" *ngIf="showDetails">
    <div class="sync-stats">
      <div class="stat-item">
        <span class="stat-label">{{ 'syncProgress.employees' | translate }}</span>
        <span class="stat-value">{{ displayedEmployees }}/{{ displayedTotalEmployees }}</span>
      </div>
      <div class="stat-item">
        <span class="stat-label">{{ 'syncProgress.aliases' | translate }}</span>
        <span class="stat-value">{{ displayedAliases }}/{{ displayedTotalAliases }}</span>
      </div>
    </div>
    
    <div class="error-section" [class.error]="progress.status === 'ERROR'" *ngIf="hasErrors(progress) && (progress.status === 'ERROR' || auth.isSuperAdmin)">
      <div class="error-header">
        <mat-icon class="error-icon">warning</mat-icon>
        <span class="error-title">{{ (progress.status === 'COMPLETED_WITH_ERROR' ? 'syncProgress.syncFailedSuperAdmin' : 'syncProgress.syncFailed') | translate }}</span>
      </div>
      
      <div class="general-error" *ngIf="progress.errorMessage">
        <div class="error-label">{{ 'syncProgress.errorDetails' | translate }}</div>
        <div class="error-message" [innerHTML]="progress.errorMessage | translate"></div>
      </div>
      
      <div class="individual-errors" *ngIf="getFailedSyncs(progress).length > 0">
        <div class="error-label">{{ 'syncProgress.individualErrors' | translate }}</div>
        <div class="error-list">
          <div class="error-item" *ngFor="let sync of getFailedSyncs(progress)">
            <mat-icon class="error-item-icon">person</mat-icon>
            <div class="error-item-content">
              <div class="error-email">{{ sync.email }}</div>
              <div class="error-text">{{ sync.error }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div
      class="recent-syncs"
      [class.expanded]="showAllSyncs"
      *ngIf="recentSyncs.length > 0 || loadingAllSyncs"
    >
      <div class="recent-syncs-header">
        <div class="recent-syncs-title">{{ 'syncProgress.recentlyProcessed' | translate }}</div>
        <button
          mat-button
          (click)="toggleAllSyncs()"
          class="toggle-all-syncs-btn"
          *ngIf="(progress.totalSyncs ?? 0) > 5"
          [disabled]="loadingAllSyncs"
        >
          <mat-icon>{{ showAllSyncs ? 'expand_less' : 'expand_more' }}</mat-icon>
          {{ showAllSyncs ? ('syncProgress.showLess' | translate) : ('syncProgress.showAll' | translate) }}
        </button>
      </div>

      <div class="sync-list-loader" *ngIf="loadingAllSyncs">
        <mat-spinner diameter="24"></mat-spinner>
      </div>

      <div class="sync-item" *ngFor="let sync of (showAllSyncs ? allSyncs : recentSyncs)">
        <mat-icon class="sync-item-icon" [class.error]="sync.error">{{ sync.isAlias ? 'alternate_email' : 'person' }}</mat-icon>
        <span class="sync-email">{{ sync.email }}</span>
        <span class="sync-time">{{ formatTime(sync.finishedAt) }}</span>
      </div>
    </div>
  </div>
  
  <div class="sync-actions">
    <button mat-button (click)="toggleDetails()" class="toggle-details-btn">
      <mat-icon>{{ showDetails ? 'expand_less' : 'expand_more' }}</mat-icon>
      {{ showDetails ? ('syncProgress.hideDetails' | translate) : ('syncProgress.showDetails' | translate) }}
    </button>
    <button mat-button (click)="closeProgress()" class="close-btn" *ngIf="isCompleted(progress.status)">
      <mat-icon>close</mat-icon>
      {{ 'syncProgress.close' | translate }}
    </button>
  </div>
</div>
